import { cn } from "@workspace/frontend-ui";

type Props = {
  className?: string;
};

const GameDetailsInline: FC<Props> = ({ children, className }) => (
  <div
    className={cn(
      "grid grid-flow-col items-center justify-between gap-2 rounded-lg bg-secondary px-3 py-2 md:min-w-[18.75rem]",
      className,
    )}
  >
    {children}
  </div>
);

export default GameDetailsInline;
